import { Box, Stack } from '@mui/joy'
import { ReactNode, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Alert } from '~/shared/ui/Alerts'
import { Button } from '~/shared/ui/Buttons'
import { CanceledIcon } from '~/shared/ui/Icons'
import { Modal } from '~/shared/ui/Modal'

type CanceledModalProps = {
  isShow: boolean
  onOk: () => Promise<void>
  onCancel: () => void
  extraBlock?: ReactNode
  buttonSuccessTitle?: string
}

export const CanceledModal = ({
  isShow,
  onOk,
  onCancel,
  extraBlock,
  buttonSuccessTitle,
}: CanceledModalProps) => {
  const { t } = useTranslation()
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)

  const handleSuccess = useCallback(async () => {
    try {
      setIsSubmitting(true)
      await onOk()
      onCancel()
    } finally {
      setIsSubmitting(false)
    }
  }, [onCancel, onOk])

  return (
    <Modal
      isShow={isShow}
      onCancel={isSubmitting ? undefined : onCancel}
      dialogProps={{
        sx: {
          minWidth: '600px',
          maxWidth: '600px',
        },
      }}
    >
      {extraBlock || (
        <Alert variant='info' sx={{ margin: '44px 0 24px 0' }}>
          {t('alert.annul contract')}
        </Alert>
      )}

      <Box sx={{ padding: '4px' }}>
        <Stack direction='row' justifyContent='space-between' spacing={2}>
          <Button
            variant='gray'
            onClick={onCancel}
            disabled={isSubmitting}
            fullWidth
          >
            {t('button.cancel')}
          </Button>
          <Button
            variant='textRed'
            loading={isSubmitting}
            fullWidth
            startDecorator={<CanceledIcon />}
            onClick={handleSuccess}
          >
            {buttonSuccessTitle || t('button.annul')}
          </Button>
        </Stack>
      </Box>
    </Modal>
  )
}
